
module.exports = require('./blob').toBase64Url;
